import {
  AmendmentCellDisplay,
  BiomassBurningCellDisplay,
  CashCropCellDisplay,
  CoverCropCellDisplay,
  FertilizerCellDisplay,
  IrrigationCellDisplay,
  LimingCellDisplay,
  LivestockCellDisplay,
  NaturalDisturbanceCellDisplay,
  TillageCellDisplay,
  WaterPumpIrrigationCellDisplay,
} from '@cibo/landmanager'
import { ComponentType } from 'react'

export const TRAIT_DISPLAY_MAP: Record<string, ComponentType<{ value: any }>> = {
  amendment: AmendmentCellDisplay,
  biomassBurning: BiomassBurningCellDisplay,
  cashCrop: CashCropCellDisplay,
  coverCrop: CoverCropCellDisplay,
  fertilizer: FertilizerCellDisplay,
  irrigation: IrrigationCellDisplay,
  liming: LimingCellDisplay,
  livestock: LivestockCellDisplay,
  naturalDisturbance: NaturalDisturbanceCellDisplay,
  tillage: TillageCellDisplay,
  waterPumpIrrigation: WaterPumpIrrigationCellDisplay,
}
